import home from './home.js';
import pclabIntro2 from './pclabIntro2.js';
import platKsedu from './platKsedu.js';
import plt from './plt.js';
import pltUpload from './pltUpload.js';
import register from './register.js';
import result from './result.js';
import sso from './sso.js';
import statistics from './statistics.js';
import upload from './upload.js';
import { asDvaModel } from './dva-types.js';

export default [
  asDvaModel(home),
  asDvaModel(pclabIntro2),
  asDvaModel(platKsedu),
  asDvaModel(plt),
  asDvaModel(pltUpload),
  asDvaModel(register),
  asDvaModel(result),
  asDvaModel(sso),
  asDvaModel(statistics),
  asDvaModel(upload),
];
